import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import API from "../api/client";

const HUB_BASE = process.env.REACT_APP_HUB_URL || "https://sso-engine-1.preview.emergentagent.com";
const LOGIN_RETURN_PATH = "/login?return_to=";

export default function SSOAcceptPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [processing, setProcessing] = useState(true);

  useEffect(() => {
    const token = searchParams.get("sso_token");
    if (!token) {
      setError("Missing sso_token.");
      setProcessing(false);
      return;
    }

    // Strip sso_token from URL immediately (security: prevent leaking via referrer/history)
    window.history.replaceState(null, "", window.location.pathname);

    API.post("/sso/accept", { sso_token: token })
      .then((res) => {
        // Store tenant branding if provided
        if (res.data.tenant_branding) {
          try { sessionStorage.setItem("tenant_branding", JSON.stringify(res.data.tenant_branding)); } catch {}
        }
        if (res.data.tenant_name) {
          try { sessionStorage.setItem("tenant_name", res.data.tenant_name); } catch {}
        }
        // Redirect to dashboard - full page load to pick up new cookies
        window.location.href = "/dashboard";
      })
      .catch(err => {
        const detail = err.response?.data?.detail || "SSO authentication failed";
        setError(detail);
        setProcessing(false);
      });
  }, [searchParams, navigate]);

  const isExpired = error.toLowerCase().includes("expired");
  const appUrl = encodeURIComponent(window.location.origin);

  return (
    <div className="min-h-screen bg-[#F9F9FB] flex items-center justify-center" data-testid="sso-accept-page">
      <div className="text-center max-w-sm">
        {processing && !error && (
          <>
            <div className="animate-spin rounded-full h-8 w-8 border-2 border-[#111216] border-t-transparent mx-auto mb-4" />
            <p className="text-sm text-[#686B74]">Authenticating via CargoDash Hub...</p>
          </>
        )}
        {error && (
          <div className="bg-white border border-[#EBEBEB] rounded-lg p-6">
            <p className="text-sm text-[#E24A4A] mb-4">{error}</p>
            {isExpired ? (
              <a
                href={`${HUB_BASE}${LOGIN_RETURN_PATH}${appUrl}`}
                className="inline-block text-sm font-medium text-white bg-[#111216] px-4 py-2 rounded-md hover:bg-[#2B2D31] transition-colors"
                data-testid="return-to-hub-btn"
              >
                Return to Hub Login
              </a>
            ) : (
              <button
                onClick={() => navigate("/login")}
                className="text-sm text-[#4353FF] hover:underline"
              >
                Go to login
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
